import React, { Component } from 'react';
import BasePage from './BasePage';
import Session from '../services/session'
import Banner from '../partials/Banner';
import i from '../imports';
import c from '../components';
import d from '../dialogs';
import session from '../services/session';

import BreadCrumbs from '../partials/BreadCrumbs';

const EMPTY_FILTER_VALUE = "empty_filter_value";

const floatingLabelStyle = {
    color: "#FF5563"
}

const underlineStyle = {
    borderColor: "#FF5563"
}

class TransferPage extends Component {
    constructor() {
        super();
        this.state = {
            dateValue: new Date(),
            languageValue: EMPTY_FILTER_VALUE,
            transfersNumberValue: 1,
            openDialog: false
        }
    }

    handleDateChange = (event, date) => this.setState({
        dateValue: date
    });

    handleLanguageChange = (event, index, value) => this.setState({
        languageValue: value
    });
    handleTransferNumberChange = (event, index, value) => this.setState({
        transfersNumberValue: value
    });

    handleCloseDialog = () => {
        this.setState({
            openDialog: false
        })
    }
    handleOpenDialog = () => {
        this.setState({
            openDialog: true
        })
    }

    updateCalcValues = (calcValues) => {
        console.log(calcValues);
        this.setState({
            transfersNumberValue: calcValues.transfersNumberValue,
            languageValue: calcValues.languageValue,
            dateValue: calcValues.dateValue
        });
    }

    render() {
        let currentTransfer = this.props.data;
        let currentDest = Session.model.destinationPages.filter(dest => dest.name == currentTransfer.destination)[0];
        let otherTransfers = Session.model.transfersPages.filter(transfer =>
            transfer.destination == currentTransfer.destination
            && transfer.name != currentTransfer.name
        ).slice(0, 3);

        let transfers = Session.model.transfers;
        console.log(transfers);

        // <Banner images={Session.getBannerPictures(currentTransfer.banner)}
        //     title={currentTransfer.translations[0].title}
        //     text={currentTransfer.translations[0].short_text}
        // />

        return (
            <BasePage data={this.props.data}>
                <BreadCrumbs fullpath={window.location.pathname} name={currentTransfer.translations[0].title} />
                <i.PureGridProvider>
                    <i.Container>
                        <i.Row>
                            <i.Col md={12} align='left'>
                                {i.markdown(currentTransfer.translations[0].text)}
                            </i.Col>
                        </i.Row>
                        <i.Row>
                            <i.Col align="left">
                                <div style={{
                                    color: "#FF5563",
                                    fontSize: 18,
                                    paddingTop: 20,
                                    fontWeight: "bold"
                                }}>{session.model.transfers.transfer_calc}</div>
                            </i.Col>
                        </i.Row>
                        <i.Row align="end">
                            <i.Col xs={12} sm={6} md={3}>

                                <i.DatePicker
                                    fullWidth
                                    hintText="Controlled Date Input"
                                    floatingLabelStyle={floatingLabelStyle}
                                    underlineFocusStyle={underlineStyle}
                                    underlineStyle={underlineStyle}
                                    floatingLabelText={Session.model.common.words.date}
                                    value={this.state.dateValue}
                                    onChange={this.handleDateChange}
                                />
                            </i.Col>
                            <i.Col xs={12} sm={6} md={3} align='left'>
                                <i.SelectField
                                    floatingLabelText={Session.model.common.words.language}
                                    floatingLabelStyle={floatingLabelStyle}
                                    fullWidth
                                    value={this.state.languageValue}
                                    onChange={this.handleLanguageChange}
                                    underlineFocusStyle={underlineStyle} underlineStyle={underlineStyle}
                                >
                                    <i.MenuItem value={EMPTY_FILTER_VALUE} primaryText={Session.model.transfers.languages.choose_language} />
                                    <i.MenuItem value="Eng" primaryText={Session.model.transfers.languages.en} />
                                    <i.MenuItem value="Ru" primaryText={Session.model.transfers.languages.ru} />
                                </i.SelectField>
                            </i.Col>
                            <i.Col xs={12} sm={6} md={3} align='left'>
                                <i.SelectField
                                    floatingLabelText={Session.model.transfers.number_of_guests}
                                    floatingLabelStyle={floatingLabelStyle}
                                    fullWidth
                                    underlineFocusStyle={underlineStyle}
                                    underlineStyle={underlineStyle}
                                    value={this.state.transfersNumberValue}
                                    onChange={this.handleTransferNumberChange}
                                >
                                    <i.MenuItem value={1} primaryText={"1"} />
                                    <i.MenuItem value={2} primaryText={"2"} />
                                    <i.MenuItem value={3} primaryText={"3"} />
                                </i.SelectField>
                            </i.Col>
                        </i.Row>
                        <i.Row>
                            <i.Col align="center">
                                <div style={{
                                    color: "#FF5563",
                                    fontSize: 18,
                                    paddingTop: 40,
                                    paddingBottom: 40,
                                    fontWeight: "normal"
                                }}>{Session.model.common.words.estimated_price}:&nbsp;
                                    {(this.state.transfersNumberValue * Number(currentTransfer.price)).toLocaleString("ru-RU")}
                                    <span style={{ textTransform: "uppercase" }}> {Session.model.common.words.rub}</span>
                                </div>
                            </i.Col>
                        </i.Row>
                        <i.Row style={{ paddingBottom: 30 }}>
                            <i.Col xs={12} align="center">
                                <button className='button' onClick={this.handleOpenDialog}>{session.model.transfers.button}</button>
                                <d.TransferDialog
                                    updateCalcValues={this.updateCalcValues}
                                    form_title={Session.model.transfers.form_title}
                                    form_description={Session.model.transfers.form_description}
                                    calcValues={this.state}
                                    onClose={this.handleCloseDialog}
                                    openDialog={this.state.openDialog}
                                    currentTransfer={currentTransfer}
                                />
                                {/*<i.RaisedButton label="_REQUEST_"
                                    backgroundColor="#FF5563"
                                    labelColor="white"
                                    style={{backgroundColor: "#FF5563"}}/>*/}
                            </i.Col>
                        </i.Row>
                        {otherTransfers.length > 0 ?
                            <i.Row style={{ paddingBottom: 20 }}>
                                <i.Col>
                                    <div>
                                        <h2>{`${Session.model.transfers.other_transfers} ${currentDest.translations[0].title}`}</h2>
                                        <c.CardsList items={otherTransfers} urlBuilder={i.Utils.createTransferUrl} />
                                        <h2>Тут будет ссылка
                                            {/* <i.NavLink style={{color: "#FF5563", textDecoration: "none"}}
                                                to={i.Utils.locUrl(`tours/${currentTypeUrl}/${currentDest.name}`)}>
                                                    {Session.model.common.words.find_more}
                                            </i.NavLink> */}
                                        </h2>
                                    </div>
                                </i.Col>
                            </i.Row>
                            : null
                        }
                    </i.Container>
                </i.PureGridProvider>

            </BasePage>
        );
    }
}

export default TransferPage;